import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseSegmentComponent from "/components/segments/base-segment/base-segment-component";
import { withPreviewBaseSegment } from "contexts/preview-base-segment-context";
class SegmentsListComponent extends PureComponent {
    render() {
        const { segments, isUserLoggedIn, extraProps, isPreview } = this.props;
        const Component = isPreview ? withPreviewBaseSegment(BaseSegmentComponent) : BaseSegmentComponent;
        return segments.map((s, index)=>{
            return /*#__PURE__*/ _jsx(Component, {
                extraProps: extraProps,
                segment: s,
                isUserLoggedIn: isUserLoggedIn,
                index: index
            }, `${s.type}_${index}`);
        });
    }
}
export { SegmentsListComponent as default };
